import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  // load translations using http (default public/locales folder)
  .use(Backend)
  // detect user language
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next
  .use(initReactI18next)
  // init i18next
  .init({
    fallbackLng: 'fr',
    // Only support these specific languages
    supportedLngs: ['en', 'fr'],
    // Normalize language detection to only 'en' or 'fr'
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    // backend configuration
    backend: {
      // path where resources get loaded from
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  // define namespaces for logical separation of translations
  ns: ['common', 'auth', 'resetPassword', 'payment_link'],
  defaultNS: 'auth',
    // Disable suspense mode to prevent the error
    react: {
      useSuspense: false
    },
    detection: {
      order: ['localStorage', 'customDetector', 'navigator', 'htmlTag'],
      caches: ['localStorage'],

      lookupFromPathIndex: 0,
      lookupFromSubdomainIndex: 0,
    }
  });

const customDetector = {
  name: 'customDetector',
  lookup() {
    const storedLanguage = localStorage.getItem('i18nextLng');
    if (!storedLanguage) {
      return 'fr';
    }
    return storedLanguage;
  },
  cacheUserLanguage(lng) {
    localStorage.setItem('i18nextLng', lng);
  }
};

i18n.services.languageDetector.addDetector(customDetector);

export default i18n;
